<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="dedi"></a><a id="page_4">DEDICATION</a></h2><a id="page_4">
<p class="dedic">For my favorite sugar babies, Olivia and Sophia, and for Jim, who makes my life so sweet.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01_dedication.vue?3eaac264